function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.132 12.63a9.942 9.942 0 01.001-3.26c1.101.026 2.092-.502 2.477-1.431.385-.93.058-2.003-.74-2.763a9.942 9.942 0 012.306-2.307c.76.798 1.834 1.125 2.763.74.93-.385 1.458-1.376 1.431-2.477a9.942 9.942 0 013.261 0c-.027 1.102.502 2.092 1.431 2.477.93.385 2.003.058 2.763-.74a9.939 9.939 0 012.307 2.306c-.798.76-1.125 1.834-.74 2.764.385.93 1.375 1.458 2.477 1.43a9.945 9.945 0 010 3.262c-1.102-.027-2.092.501-2.477 1.43-.385.93-.058 2.004.74 2.764a9.939 9.939 0 01-2.306 2.306c-.76-.798-1.834-1.125-2.764-.74-.93.385-1.458 1.376-1.43 2.478a9.94 9.94 0 01-3.262-.001c.027-1.101-.502-2.092-1.43-2.477-.93-.385-2.004-.058-2.764.74a9.943 9.943 0 01-2.306-2.306c.798-.76 1.125-1.834.74-2.763-.385-.93-1.376-1.458-2.478-1.431zM11.001 14a3 3 0 100-6 3 3 0 000 6z",
  fill: "#fff"
});

function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref);
}

export default SvgSettings;